/**
 * @type {{
 *  EXCLUSIVE: string,
 *  EXCLUSIVO: string,
 *  PREMIUM: string,
 *  AI: string,
 *  IA: string,
 * }} - Meta info keys.
 */
export const META_INFO_KEYS = {
    EXCLUSIVE: 'exclusive',
    EXCLUSIVO: 'exclusivo',
    PREMIUM: 'premium',
    AI: 'ai',
    IA: 'ia',
};

/** @type {string} */
export const VIDEO_FORMAT_KEY = 'vzoom';

/** @type {string} */
export const IMAGE_UUID_ATTRIBUTE = 'img_uid';
